import apiClient from "./client";

export async function fetchAccountingDashboard(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/dashboard", { params });
  return data;
}

export async function fetchAccountingSettings() {
  const { data } = await apiClient.get("/accounting/settings");
  return data;
}

export async function updateAccountingSettings(payload) {
  const { data } = await apiClient.patch("/accounting/settings", payload);
  return data;
}

export async function fetchFinancialPeriods(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/periods", { params });
  return data;
}

export async function createFinancialPeriod(payload) {
  const { data } = await apiClient.post("/accounting/periods", payload);
  return data;
}

export async function closeFinancialPeriod(periodId) {
  const { data } = await apiClient.patch(`/accounting/periods/${periodId}/close`);
  return data;
}

export async function reopenFinancialPeriod(periodId) {
  const { data } = await apiClient.patch(`/accounting/periods/${periodId}/reopen`);
  return data;
}

export async function fetchChartOfAccounts(params = {}) {
  const { data } = await apiClient.get("/accounting/accounts", { params });
  return data;
}

export async function createChartAccount(payload) {
  const { data } = await apiClient.post("/accounting/accounts", payload);
  return data;
}

export async function updateChartAccount(accountId, payload) {
  const { data } = await apiClient.patch(`/accounting/accounts/${accountId}`, payload);
  return data;
}

export async function fetchCostCenters(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/cost-centers", { params });
  return data;
}

export async function createCostCenter(payload) {
  const { data } = await apiClient.post("/accounting/cost-centers", payload);
  return data;
}

export async function updateCostCenter(centerId, payload) {
  const { data } = await apiClient.patch(`/accounting/cost-centers/${centerId}`, payload);
  return data;
}

export async function fetchExpenseCategories(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/expense-categories", { params });
  return data;
}

export async function createExpenseCategory(payload) {
  const { data } = await apiClient.post("/accounting/expense-categories", payload);
  return data;
}

export async function updateExpenseCategory(categoryId, payload) {
  const { data } = await apiClient.patch(`/accounting/expense-categories/${categoryId}`, payload);
  return data;
}

export async function fetchVendors(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/vendors", { params });
  return data;
}

export async function createVendor(payload) {
  const { data } = await apiClient.post("/accounting/vendors", payload);
  return data;
}

export async function updateVendor(vendorId, payload) {
  const { data } = await apiClient.patch(`/accounting/vendors/${vendorId}`, payload);
  return data;
}

export async function fetchJournalEntries(params = {}) {
  const { data } = await apiClient.get("/accounting/journals", { params });
  return data;
}

export async function createJournalEntry(payload) {
  const { data } = await apiClient.post("/accounting/journals", payload);
  return data;
}

export async function postJournalEntry(entryId) {
  const { data } = await apiClient.post(`/accounting/journals/${entryId}/post`);
  return data;
}

export async function fetchGeneralLedger(params = {}) {
  const { data } = await apiClient.get("/accounting/general-ledger", { params });
  return data;
}

export async function fetchExpenses(params = {}) {
  const { data } = await apiClient.get("/accounting/expenses", { params });
  return data;
}

export async function createExpense(payload) {
  const { data } = await apiClient.post("/accounting/expenses", payload);
  return data;
}

export async function updateExpense(expenseId, payload) {
  const { data } = await apiClient.patch(`/accounting/expenses/${expenseId}`, payload);
  return data;
}

export async function submitExpense(expenseId) {
  const { data } = await apiClient.post(`/accounting/expenses/${expenseId}/submit`);
  return data;
}

export async function approveExpense(expenseId) {
  const { data } = await apiClient.post(`/accounting/expenses/${expenseId}/approve`);
  return data;
}

export async function rejectExpense(expenseId, reason) {
  const { data } = await apiClient.post(`/accounting/expenses/${expenseId}/reject`, { reason });
  return data;
}

export async function payExpense(expenseId) {
  const { data } = await apiClient.post(`/accounting/expenses/${expenseId}/pay`);
  return data;
}

export async function fetchTrialBalance(params = {}) {
  const { data } = await apiClient.get("/accounting/reports/trial-balance", { params });
  return data;
}

export async function fetchFinanceSummary(params = {}) {
  const { data } = await apiClient.get("/accounting/reports/finance-summary", { params });
  return data;
}

export async function fetchBalanceSheet(params = {}) {
  const { data } = await apiClient.get("/accounting/reports/balance-sheet", { params });
  return data;
}

export async function fetchIncomeStatement(params = {}) {
  const { data } = await apiClient.get("/accounting/reports/income-statement", { params });
  return data;
}

export async function fetchCashFlowStatement(params = {}) {
  const { data } = await apiClient.get("/accounting/reports/cash-flow", { params });
  return data;
}

export async function fetchBudgetVsActual(branchId, periodId) {
  const { data } = await apiClient.get("/accounting/reports/budget-vs-actual", {
    params: { branch_id: branchId, period_id: periodId },
  });
  return data;
}

export async function fetchPayables(branchId, status) {
  const params = {};
  if (branchId) params.branch_id = branchId;
  if (status) params.status = status;
  const { data } = await apiClient.get("/accounting/payables", { params });
  return data;
}

export async function createPayableBill(payload) {
  const { data } = await apiClient.post("/accounting/payables", payload);
  return data;
}

export async function postPayableBill(billId) {
  const { data } = await apiClient.post(`/accounting/payables/${billId}/post`);
  return data;
}

export async function payPayableBill(billId) {
  const { data } = await apiClient.post(`/accounting/payables/${billId}/pay`);
  return data;
}

export async function fetchReceivables(branchId, status) {
  const params = {};
  if (branchId) params.branch_id = branchId;
  if (status) params.status = status;
  const { data } = await apiClient.get("/accounting/receivables", { params });
  return data;
}

export async function createReceivableInvoice(payload) {
  const { data } = await apiClient.post("/accounting/receivables", payload);
  return data;
}

export async function postReceivableInvoice(invoiceId) {
  const { data } = await apiClient.post(`/accounting/receivables/${invoiceId}/post`);
  return data;
}

export async function receiveReceivablePayment(invoiceId) {
  const { data } = await apiClient.post(`/accounting/receivables/${invoiceId}/receive`);
  return data;
}

export async function fetchAccountBudgets(branchId, periodId) {
  const params = {};
  if (branchId) params.branch_id = branchId;
  if (periodId) params.period_id = periodId;
  const { data } = await apiClient.get("/accounting/budgets", { params });
  return data;
}

export async function createAccountBudget(payload) {
  const { data } = await apiClient.post("/accounting/budgets", payload);
  return data;
}

export async function updateAccountBudget(budgetId, payload) {
  const { data } = await apiClient.patch(`/accounting/budgets/${budgetId}`, payload);
  return data;
}

export async function deleteAccountBudget(budgetId) {
  await apiClient.delete(`/accounting/budgets/${budgetId}`);
}

export async function fetchPettyCashFunds(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/petty-cash/funds", { params });
  return data;
}

export async function createPettyCashFund(payload) {
  const { data } = await apiClient.post("/accounting/petty-cash/funds", payload);
  return data;
}

export async function fetchPettyCashTransactions(fundId) {
  const { data } = await apiClient.get(`/accounting/petty-cash/funds/${fundId}/transactions`);
  return data;
}

export async function createPettyCashTransaction(payload) {
  const { data } = await apiClient.post("/accounting/petty-cash/transactions", payload);
  return data;
}

export async function fetchBankReconciliations(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/bank-reconciliations", { params });
  return data;
}

export async function createBankReconciliation(payload) {
  const { data } = await apiClient.post("/accounting/bank-reconciliations", payload);
  return data;
}

export async function completeBankReconciliation(reconciliationId) {
  const { data } = await apiClient.post(`/accounting/bank-reconciliations/${reconciliationId}/complete`);
  return data;
}

export async function fetchFixedAssets(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/fixed-assets", { params });
  return data;
}

export async function createFixedAsset(payload) {
  const { data } = await apiClient.post("/accounting/fixed-assets", payload);
  return data;
}

export async function updateFixedAsset(assetId, payload) {
  const { data } = await apiClient.patch(`/accounting/fixed-assets/${assetId}`, payload);
  return data;
}

export async function fetchDepreciationRuns(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/depreciation-runs", { params });
  return data;
}

export async function createDepreciationRun(payload) {
  const { data } = await apiClient.post("/accounting/depreciation-runs", payload);
  return data;
}

export async function postDepreciationRun(runId) {
  const { data } = await apiClient.post(`/accounting/depreciation-runs/${runId}/post`);
  return data;
}

export async function fetchPayrollStaff(branchId) {
  const { data } = await apiClient.get("/accounting/payroll-staff", {
    params: { branch_id: branchId },
  });
  return data;
}

/** Active branch staff — use for custodian and other staff pickers. */
export async function fetchBranchStaff(branchId) {
  const { data } = await apiClient.get("/accounting/branch-staff", {
    params: { branch_id: branchId },
  });
  return data;
}

export async function fetchPayrollRuns(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/payroll-runs", { params });
  return data;
}

export async function createPayrollRun(payload) {
  const { data } = await apiClient.post("/accounting/payroll-runs", payload);
  return data;
}

export async function approvePayrollRun(runId) {
  const { data } = await apiClient.post(`/accounting/payroll-runs/${runId}/approve`);
  return data;
}

export async function postPayrollRun(runId) {
  const { data } = await apiClient.post(`/accounting/payroll-runs/${runId}/post`);
  return data;
}

export async function fetchTaxCodes(branchId) {
  const params = branchId ? { branch_id: branchId } : {};
  const { data } = await apiClient.get("/accounting/tax-codes", { params });
  return data;
}

export async function createTaxCode(payload) {
  const { data } = await apiClient.post("/accounting/tax-codes", payload);
  return data;
}

export async function updateTaxCode(codeId, payload) {
  const { data } = await apiClient.patch(`/accounting/tax-codes/${codeId}`, payload);
  return data;
}

export async function fetchTaxTransactions(branchId, taxCodeId) {
  const params = {};
  if (branchId) params.branch_id = branchId;
  if (taxCodeId) params.tax_code_id = taxCodeId;
  const { data } = await apiClient.get("/accounting/tax-transactions", { params });
  return data;
}

export async function createTaxTransaction(payload) {
  const { data } = await apiClient.post("/accounting/tax-transactions", payload);
  return data;
}

export async function fetchVatSummary(branchIdOrParams, dateFrom, dateTo) {
  const params =
    typeof branchIdOrParams === "object" && branchIdOrParams !== null
      ? { ...branchIdOrParams }
      : { branch_id: branchIdOrParams };
  if (dateFrom && !params.date_from) params.date_from = dateFrom;
  if (dateTo && !params.date_to) params.date_to = dateTo;
  const { data } = await apiClient.get("/accounting/reports/vat-summary", { params });
  return data;
}
